import state from '@/vuex/reencaminhamento-documento/state.js'
import getters from '@/vuex/reencaminhamento-documento/getters.js'
import mutations from '@/vuex/reencaminhamento-documento/mutations.js'
import actions from '@/vuex/reencaminhamento-documento/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
